import PropTypes from "prop-types";
import { useAddBookmarkModal } from "@/react/components/Modals/AddBookmarkModal";
import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import { useBoolean } from "@/react/hooks/utils/useBoolean";
import { BookmarkDropdownItems } from "./BookmarkDropdownItems";
import { BookmarkManageOptions } from "./BookmarkManageOptions";
import { DeleteBookmarkConfirmation } from "./DeleteBookmarkConfirmation";
import { FolderDropdown } from "./FolderDropdown";
import { useSortableBookmarkContext } from "./context/SortableBookmark";

export const FolderBookmark = ({ bookmark }) => {
  const { space, setIsFolderDropdownOpen } = useSortableBookmarkContext();
  const addBookmarkModal = useAddBookmarkModal();
  const [shouldShowDeleteConfirmation, toggleDeleteConfirmation] =
    useBoolean(false);
  const showManageOptions = userIsAdminOrModeratorOfSpace(space);

  return (
    <>
      <FolderDropdown
        bookmark={bookmark}
        onToggle={isOpen => setIsFolderDropdownOpen(isOpen)}
      >
        <BookmarkDropdownItems bookmarks={bookmark.links} />
        {showManageOptions && (
          <BookmarkManageOptions
            onCreateLinkClick={() =>
              addBookmarkModal.show({
                space: space,
                isFolder: false,
                folderId: bookmark.id,
              })
            }
            onEditFolderClick={() =>
              addBookmarkModal.show({
                space,
                bookmark,
                isFolder: true,
                isEdit: true,
              })
            }
            onDeleteClick={toggleDeleteConfirmation}
          />
        )}
      </FolderDropdown>
      <DeleteBookmarkConfirmation
        space={space}
        bookmark={bookmark}
        isOpen={shouldShowDeleteConfirmation}
        onClose={toggleDeleteConfirmation}
      />
    </>
  );
};

FolderBookmark.propTypes = {
  bookmark: PropTypes.object.isRequired,
};
